import { Button } from '@mantine/core';
import { Attachment, Reference } from '@medplum/fhirtypes';
import {
  AttachmentDisplay,
  ComplexTypeInputProps,
  killEvent,
} from '@medplum/react';
import { MouseEvent, useState } from 'react';
import { SignaturePad } from './SignaturePad';
import { useTranslation } from 'react-i18next';

export interface SignatureInputProps extends ComplexTypeInputProps<Attachment> {
  readonly arrayElement?: boolean;
  readonly securityContext?: Reference;
  readonly onChange?: (value: Attachment | undefined) => void;
}

export function SignatureInput(props: SignatureInputProps): JSX.Element {
  const [value, setValue] = useState(props.defaultValue);
  const { t } = useTranslation(['medplum-react']);

  function setValueWrapper(newValue: Attachment | undefined): void {
    setValue(newValue);
    if (props.onChange) {
      props.onChange(newValue);
    }
  }

  if (value) {
    return (
      <>
        <AttachmentDisplay value={value} maxWidth={200} />
        <Button
          disabled={props.disabled}
          onClick={(e: MouseEvent) => {
            killEvent(e);
            setValueWrapper(undefined);
          }}
        >
          {t('questionnaireForm.buttons.remove', 'Remove', {
            ns: 'medplum-react',
          })}
        </Button>
      </>
    );
  }

  return (
    <SignaturePad
      disabled={props.disabled}
      securityContext={props.securityContext}
      onUpload={setValueWrapper}
    />
  );
}
